import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import SsoLogin from "@/pages/SsoLogin";
import PaymentReturn from "@/pages/PaymentReturn";
import Pricing from "@/pages/Pricing";
import TenantPricing from "@/pages/TenantPricing";
import Messages from "@/pages/Messages";
import Privacy from "@/pages/Privacy";
import Support from "@/pages/Support";
import TenantDashboard from "@/pages/tenant/TenantDashboard";
import ProfileBuilder from "@/pages/tenant/ProfileBuilder";
import LandlordDashboard from "@/pages/landlord/LandlordDashboard";
import Admin from "@/pages/Admin";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

const TENANT_ONLY = ["tenant"];
const LANDLORD_ONLY = ["landlord"];
const ADMIN_ONLY = ["admin"];

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Landing />;
  if (user.role === "tenant") return <Navigate to="/tenant" replace />;
  if (user.role === "landlord") return <Navigate to="/landlord" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return <Landing />;
}

function App() {
  return (
    <div className="App min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/sso" element={<SsoLogin />} />
            <Route path="/payment/return" element={<PaymentReturn />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/tenant-pricing" element={<TenantPricing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/support" element={<Support />} />
            <Route path="/messages" element={<Protected><Messages /></Protected>} />
            <Route path="/tenant" element={<Protected roles={TENANT_ONLY}><TenantDashboard /></Protected>} />
            <Route path="/tenant/profile" element={<Protected roles={TENANT_ONLY}><ProfileBuilder /></Protected>} />
            <Route path="/landlord" element={<Protected roles={LANDLORD_ONLY}><LandlordDashboard /></Protected>} />
            <Route path="/admin" element={<Protected roles={ADMIN_ONLY}><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
